import React from 'react';
import { isPlainLeftClick } from './isPlainLeftClick.js';
import { iconSlotOffset, SidebarStyle } from './sidebarStyle.js';
import { SidebarTooltip } from './SidebarTooltip.jsx';

export function SidebarRow({
  geometry,
  label,
  selected = false,
  onClick,
  href,
  external = false,
  menuExpanded,
  iconContent,
  textContent,
  inset = 0,
  height = SidebarStyle.ITEM_HEIGHT,
  iconSlot = SidebarStyle.ICON_SLOT,
}) {
  const onRowClick = (event) => {
    if (href != null && !external) {
      if (!isPlainLeftClick(event)) return;
      event.preventDefault();
    }
    onClick?.(event);
  };

  const props = {
    className: `vs-row${selected ? ' is-selected' : ''}`,
    style: { height, padding: `0 ${geometry.rail ? 0 : inset}px` },
    'aria-label': label,
    'aria-current': selected ? 'page' : undefined,
    'aria-haspopup': menuExpanded != null ? 'menu' : undefined,
    'aria-expanded': menuExpanded,
    onClick: onRowClick,
  };

  const content = (
    <>
      <span
        className="vs-icon-slot"
        style={{ width: iconSlot, transform: `translateX(${iconSlotOffset(geometry, iconSlot)}px)` }}
      >
        {iconContent}
      </span>
      {textContent != null && (
        <span className={`vs-text vs-reveal${geometry.rail ? ' is-hidden' : ''}`}>{textContent}</span>
      )}
    </>
  );

  const row = href == null ? (
    <button type="button" {...props}>{content}</button>
  ) : (
    <a href={href} {...props}>{content}</a>
  );

  return <SidebarTooltip text={label} enabled={geometry.rail}>{row}</SidebarTooltip>;
}
